var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title-wrap__head"},[(!_vm.$slots.custom)?_c('h3',[_vm._v(_vm._s(_vm.Title))]):_vm._e(),_vm._t("custom")],2),_c('v-divider',{staticClass:"v-divider__primary",class:[_vm.userTheme]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }